module.exports = "/images/interrogante.svg?121cca690e39f83a401a4eaca97ad47c";